// Hero Section Component
import { I18nManager } from "../../services/i18n-manager";

export class HeroSection {
  private i18nManager: I18nManager;

  constructor(i18nManager: I18nManager) {
    this.i18nManager = i18nManager;
  }

  init(): void {
    this.setupEventListeners();
    this.updateContent();
  }

  private setupEventListeners(): void {
    // Listen for language changes
    this.i18nManager.onLanguageChange(() => {
      this.updateContent();
    });

    // Listen for theme changes
    document.addEventListener("theme-changed", () => {
      this.updateAnimations();
    });
  }

  private updateContent(): void {
    const heroTitle = document.querySelector(".hero-title");
    const heroDescription = document.querySelector(".hero-description");
    const heroCTA = document.querySelector(".hero-cta");

    if (heroTitle) {
      const line1 = this.i18nManager.t("hero.title_line1");
      const line2 = this.i18nManager.t("hero.title_line2");

      let titleHTML = `
        <span class="hero-title-line">${line1}</span>
        <span class="hero-title-line">${line2}</span>
      `;

      // Only add third line if translation exists (if missing, t() returns the key)
      const line3Key = "hero.title_line3";
      const line3 = this.i18nManager.t(line3Key);
      if (line3 && line3.trim() !== "" && line3 !== line3Key) {
        titleHTML += `<span class="hero-title-line">${line3}</span>`;
      }

      heroTitle.innerHTML = titleHTML;
    }

    if (heroDescription) {
      heroDescription.textContent = this.i18nManager.t("hero.description");
    }

    if (heroCTA) {
      heroCTA.textContent = this.i18nManager.t("hero.cta");
    }
  }

  private updateAnimations(): void {
    // Update hero shapes based on theme
    const heroShapes = document.querySelectorAll(".hero-shape");
    heroShapes.forEach((shape, index) => {
      const element = shape as HTMLElement;
      element.style.animationDelay = `${index * 0.5}s`;
    });
  }

  // Public method to trigger scroll to products
  public scrollToProducts(): void {
    const productSection = document.querySelector(".product-section");
    if (productSection) {
      productSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  // Public method to update hero content
  public updateHeroContent(
    title: string,
    description: string,
    ctaText: string
  ): void {
    const heroTitle = document.querySelector(".hero-title");
    const heroDescription = document.querySelector(".hero-description");
    const heroCTA = document.querySelector(".hero-cta");

    if (heroTitle) {
      heroTitle.innerHTML = `
        <span class="hero-title-line">${title}</span>
      `;
    }

    if (heroDescription) {
      heroDescription.textContent = description;
    }

    if (heroCTA) {
      heroCTA.textContent = ctaText;
    }
  }
}
